<template>
  <container-app>
    <header-app
      :title="$t('Hotel Information')"
      class="header-brand"
      to="menu"
    />
    <wrap>
      <ValidationObserver v-slot="{ invalid }">
        <form
          ref="form"
          @submit.prevent="checkOut"
        >
          <div class="form-group feedback-input">
            <h4>{{ $t('Please_Enter_Room_Information') }}</h4>
          </div>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="HotelName"
          >
            <div class="form-group">
              <label>{{ $t('Hotel') }}/{{ $t('Restaurant')}}</label>
              <input
                v-model="model.location"
                type="text"
                class="form-control" :disabled="true"
                :placeholder="$t('Enter_hotel_name')"
              >
              <span class="error">{{ errors[0] }}</span>
            </div>
          </validation-provider>

          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="RoomNumber"
          >

            <div class="form-group">
              <label>{{ $t('Room_Number') }}</label>
<!--              <input-->
<!--                v-model="model.room_number"-->
<!--                type="text"-->
<!--                class="form-control"-->
<!--                :placeholder="$t('Enter_room_number')"-->
<!--              >-->
              <base-select :options="rooms" v-model="model.room_number"
                           option-label="name"
                           :placeholder="$t('Enter_room_number')"
                           :required="true"></base-select>
              <span class="error">{{ errors[0] }}</span>
            </div>
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            name="FirstName"
          >
            <div class="form-group">
              <label>{{ $t(`BookerName`) }}</label>
              <input
                v-model="model.customer_first_name"
                type="text"
                class="form-control"
                :placeholder="$t(`Enter`) + ' ' + $t(`BookerName`)"
              >
              <span class="error">{{ errors[0] }}</span>
            </div>
          </validation-provider>

          <validation-provider
            v-slot="{ errors }"
            rules="required|numeric"
            name="phoneNumber"
          >
            <div class="form-group">
              <label>{{ $t('Phone Number') }}</label>
              <input
                v-model="model.customer_phone_number"
                type="text"
                class="form-control"
                :placeholder="$t('enter_phone_number')"
              >
              <span class="error">{{ errors[0] }}</span>
            </div>
          </validation-provider>

          <loading-location v-if="loading" />
          <button
            type="submit"
            class="btn btn-brand btn-md mt-3"
            :disabled="invalid"
          >
            {{ $t('Submit') }}
          </button>
        </form>
      </ValidationObserver>
    </wrap>
  </container-app>
</template>

<script>
  import store from "@/store";
  import BaseSelect from "../ui_components/select";

  export default {
    components: {BaseSelect},
    layout: "default",
    name: "RoomSelection",
    middleware: ["has_order"],
    metaInfo: {
      title: "DiscoverLao Ordering"
    },
    data() {
      return {
        model: {
          room_number: "",
          customer_first_name: "",
          location: "",
          customer_phone_number: ""
        },
      };
    },
    computed: {
      loading() {
        return store.getters["order/loading"];
      },
      order_info() {
        return store.getters["order/order_info"];
      },
      state_order() {
        return store.getters["order/state_order"];
      },
      btn_state() {
        return store.getters["location_selected/btnState"];
      },
      placeSelected() {
        return store.getters["location_selected/placeSelected"];
      },
      hotel() {
        return store.getters["location_selected/placeSelected"] || {};
      },
      hotelType() {
        return store.getters["location_selected/placeType"];
      },
      rooms() {
        return store.getters["location/locations"] || [];
      },
    },
    mounted() {
      this.setData();
      if (this.btn_state != "hotel_guest") {
        if (this.placeSelected) {
          this.$router.push({
            name: "detail",
            params: {id: this.placeSelected.slug}
          });
        } else {
          this.$router.push("/");
        }
      }
      this.getData();
    },
    methods: {
      setData() {
        this.model = this.order_info;
        this.model.location = this.placeSelected.title;
      },
      async getData() {
        let data = {
          type_id: this.hotel.id,
          type: 'ROOM',

        };
        await store.dispatch("location/getLocations", data);

      },
      async checkOut() {
        await this.$store.dispatch("order/setOrderInfo", this.model);
        await store.dispatch("order/submitPendingOrder", {id: 0});
        if (this.state_order) {
          await this.$store.dispatch("order/clearOrder");
          await this.$router.push({name: "ordercompleted"});
        }
      }
    }
  };
</script>